import React from 'react';
import {connect} from 'react-redux';
import loadable from '@loadable/component';
import {EdapProvider} from '@homeaway/react-event-tracking';
import {lazy} from '../../../templates/helpers';
import {TESTS} from '../../../utils/abacus';
import MvtTest from '../../../components/common/mvt/MvtTest/MvtTest';

import {
    CACHE as LOADING_CACHE,
    placeholderFromType,
} from '../../common/loading';

const defaultFields = {
    actionlocation: 'property-reviews',
    action_location: 'property-reviews',
};

const LoadableReviews = loadable(() =>
    import(
        /* webpackChunkName: "unit-reviews" */
        './Reviews'
    )
);

function fullExposure(experiments, element) {
    return (
        <>
            {experiments.map((experiment) => (
                <MvtTest
                    key={`report-${experiment}`}
                    test={experiment}
                    reportOnMount
                />
            ))}
            {element}
        </>
    );
}

const BaseReviews = ({renderMode, ...rest}) => {
    const placeholder = placeholderFromType(ReviewsModule); // eslint-disable-line no-use-before-define
    const experiments = [
        TESTS.SERVER_SIDE_REVIEWS,
        TESTS.SERVER_SIDE_REVIEWS_TRAFFIC,
    ];
    const element = (
        <EdapProvider fields={defaultFields}>
            <LoadableReviews fallback={placeholder} {...rest} />
        </EdapProvider>
    );

    if (renderMode === 'server') {
        return fullExposure(experiments, element);
    }

    if (renderMode === 'client') {
        return fullExposure(experiments, lazy(element));
    }

    return lazy(element);
};

const mapStateToProps = ({options = {}}) => ({
    renderMode: options.reviewsRenderMode,
});

const ReviewsModule = connect(mapStateToProps)(BaseReviews);

LOADING_CACHE.set(ReviewsModule, {
    cardType: 'CardType3',
    componentType: 'ReviewsModule',
    placeholderType: 'Carousel',
    size: 'lg',
});

export default ReviewsModule;
